import {
  getAvailableIntegrationsQueryOptions,
  getIntegrationsQueryOptions,
} from "@/queries/integrations";
import {
  createFileRoute,
  Outlet,
  redirect,
  retainSearchParams,
} from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import z from "zod";

export const Route = createFileRoute(
  "/_dashboard/settings/_admin/integrations",
)({
  validateSearch: zodValidator(
    z.object({
      returnTo: z
        .union([
          z.literal("campaign-setup"),
          z.custom<`campaign/${number}`>((value) => {
            return typeof value === "string" && /^campaign\/\d+$/.test(value);
          }),
        ])
        .optional()
        .catch(undefined),
    }),
  ),
  staticData: {
    meta: {
      title: "Integrationer",
    },
  },
  search: {
    middlewares: [retainSearchParams(["returnTo"])],
  },
  beforeLoad: async ({ context }) => {
    if (
      !context.appConfiguration.features.canUseIntegration ||
      context.trialPeriod
    )
      throw redirect({ from: Route.fullPath, to: ".." });
  },
  component: () => <Outlet />,
  loader: async ({ context }) => {
    const availableIntegrations = await context.queryClient.ensureQueryData(
      getAvailableIntegrationsQueryOptions(),
    );
    const integrations = await context.queryClient.ensureQueryData(
      getIntegrationsQueryOptions(),
    );
    return {
      integrations,
      availableIntegrations,
    };
  },
});
